import React from 'react';
import SmallMetricCard from '../common/SmallMetricCard';
import OverviewCard from '../overview/OverviewCard';
import {
    UserOutlined,
    PlusCircleOutlined,
    SafetyCertificateOutlined
} from '@ant-design/icons';
import { Card, Typography } from 'antd';
import { ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';


const { Text, Title } = Typography;

// --- Config for Pixel Match ---
const CONFIG = {
  colors: {
    achieved: '#ff8c00',    // Vibrant Orange
    remaining: '#fff7ed',   // Light cream background track
    stroke: '#f3f4f6'       // Subtle border
  },
  values: {
    displayValue: '8,700,000',
    currency: '₹',
    target: '10,000,000',
    percentage: 87
  }
};


 

// Common reusable card wrapper
const CommonCard: React.FC<{ title: string; children: React.ReactNode; className?: string; }> = ({
    title,
    children,
    className = ""
}) => (
    <div className="bg-white rounded-lg shadow p-4 h-[130px] flex flex-col justify-between   ">
        <h3 className="text-sm font-semibold text-gray-700">{title}</h3>
        {children}
    </div>
);

const DashboardTop: React.FC = () => {
   const data = [
    { name: 'Achieved', value: CONFIG.values.percentage },
    { name: 'Remaining', value: 100 - CONFIG.values.percentage },
  ];



    return (
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6  mt-6">


           <Card 
      className="shadow-md rounded-2xl flex flex-col justify-center !p-0"
      bordered={false}
      style={{ width: 305,  }} 
       bodyStyle={{ padding: 0 }}
    >
 <div className="mt-auto pt-2 border-t border-gray-50 ">
        <Title level={4} className="text-center" style={{ margin: 0 }}>
          Target vs Achieved
        </Title>
      </div>


      <div className="relative h-54 w-full flex items-center justify-center">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="75%"
              innerRadius={85}
              outerRadius={115}
              startAngle={180}
              endAngle={0}
              paddingAngle={0}
              dataKey="value"
              stroke="none"
            >
              <Cell fill={CONFIG.colors.achieved} />
              <Cell 
                fill={CONFIG.colors.remaining} 
                stroke={CONFIG.colors.stroke} 
                strokeWidth={1} 
              />
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        
     
        <div className="absolute bottom-10 inset-0 flex flex-col items-center justify-end pb-6">
          <div className="text-center">
            <h3 className="text-xl font-black text-slate-800 tracking-tight">
              {CONFIG.values.displayValue} {CONFIG.values.currency}
            </h3>
            <p className="text-gray-400 text-xs mt-1 font-medium">
              Out of {CONFIG.values.target}{CONFIG.values.currency} target
            </p>
          </div>
        </div>
      </div>

 
     
    </Card>



            <div className="col-span-1 flex flex-col gap-6">

                {/* Revenue Card */}
                <CommonCard title="Revenue"  >
                    <span className=" leading-none">
                        8,700,000 ₹
                    </span>
                    <div className="flex justify-between items-end">

                        <figure>
                            <img src="https://image2url.com/images/1765286490575-d6acb22e-a351-460c-afbb-fe3f5081704c.png" alt="" />
                        </figure>


                        <div className="flex items-center text-green-600  ml-4">
                            +4.6%

                            <span className="ml-1">▲</span>
                        </div>
                    </div>



                </CommonCard>

                {/* Profit Card */}
                <CommonCard title="Profit" className={`mt-2`}>
                    <span className=" leading-none">
                        8,700,000 ₹
                    </span>
                    <div className="flex justify-between items-end">

                        <figure>
                            <img src="https://image2url.com/images/1765286607871-75b62e59-bfd2-47a4-8a3c-c82fc2994829.png" alt="" />
                        </figure>


                        <div className="flex items-center text-green-400  ml-4">
                            +4.6%

                            <span className="ml-1">▲</span>
                        </div>
                    </div>
                </CommonCard>
            </div>

            <div className="col-span-1 flex flex-col gap-6">
                <SmallMetricCard
                    value={850}
                    label="Sales Achieved"
                    Icon={PlusCircleOutlined}
                    iconColor="text-green-500"
                    trend="+5.6%"
                    trendType="up"
                    className="h-[130px]"
                />

                <SmallMetricCard
                    value="85.0%"
                    label="Conversion Rate"
                    Icon={SafetyCertificateOutlined}
                    iconColor="text-red-500"
                    trend="+5.6%"
                    trendType="up"
                    className="h-[130px]"
                />
            </div>

            {/* ---------- Leads Overview ---------- */}
            <div className="col-span-1 gap-6">
                <OverviewCard
                    title="Leads Overview"
                    data={[
                        {
                            value: 223,
                            label: 'Leads Generated',
                            Icon: UserOutlined,
                            iconColor: 'text-blue-500',
                            trend: '+5.6%',
                            trendType: 'up'
                        },
                        {
                            value: 147,
                            label: 'Leads Contacted',
                            Icon: UserOutlined,
                            iconColor: 'text-teal-500',
                            trend: '-2%',
                            trendType: 'down'
                        },
                        {
                            value: 76,
                            label: 'Leads Qualified',
                            Icon: UserOutlined,
                            iconColor: 'text-green-500',
                            trend: '+5.6%',
                            trendType: 'up'
                        },
                    ]}
                />
            </div>
        </div>
    );
};

export default DashboardTop;
